<template>
    <div>
        <div class="border-b border-black">
            <div v-if="canBePaused" @click="onPause" class="deliveryAddressCard__action">
                <p class="no-margin" v-text="$t('MANAGE_DELIVERY_PAUSE')"></p>
                <img class="deliveryAddressCard__actionIcon" src="@/assets/images/decoration/nav-pause.png">
            </div>

            <resume-deliveries v-else :subscription="subscription"/>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SUBSCRIPTION_STATUS_ACTIVE, SUBSCRIPTION_STATUS_PAUSED } from '@/constants/Subscription';
import ResumeDeliveries from '@/components/partials/account/my-delivery-schedule/manage-delivery/ResumeDeliveries';
import { CSPageEvents } from '@/helpers/GAHelpers';

export default {
    name: 'PauseButton',
    components: {
        ResumeDeliveries,
    },
    props: {
        subscription: {
            required: true,
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            pauseAllowed: 'account/getAllowPaused',
        }),
        canBePaused() {
            return (this.subscription.status === SUBSCRIPTION_STATUS_ACTIVE) && !this.subscription.paused_until;
        },
        isAccountPaused() {
            return this.subscription.status === SUBSCRIPTION_STATUS_PAUSED;
        },
        isAddressesPage() {
            return this.$route.name === 'account.delivery-addresses';
        },
    },
    methods: {
        onPause() {
            if (!this.pauseAllowed) {
                return this.$emit('toggleCantPauseModal');
            }
            this.$store.commit('account/setIsPauseFlow', true);
            this.$router.push({ name: 'account.pause-account' });
            CSPageEvents('pause-intention');
        },
    },
};
</script>
